import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {patchSubProduct} from 'services/farm/advertisement/add/subProductsOfProducts';

const useSetSubProduct = (guid: string) => {
  const navigate = useNavigate();
  const {mutate} = useMutation({
    mutationFn: ({
      cultivation_guid,
      subproduct_guid,
    }: IPatchSubProductPayload) => {
      return patchSubProduct({cultivation_guid, subproduct_guid});
    },
    onSuccess: () => {
      navigate('/farm/add-ad/type-ads', {
        state: {
          cultivationGuid: guid,
        },
      });
    },
    onError: () => {
      toast.error('خطای ارتباط با سرور');
    },
  });
  return {mutate};
};

export default useSetSubProduct;
